import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { LanguageRoutingService } from '../services/language-routing.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  constructor(private languageRoutingService: LanguageRoutingService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const langParam = route.params['lang'];
    const supportedLanguages = this.languageRoutingService.getSupportedLanguages();

    // If language parameter exists, validate it
    if (langParam) {
      if (supportedLanguages.includes(langParam)) {
        return true;
      } else {
        const defaultLang = this.languageRoutingService.getCurrentLanguage();
        const fullPath = route.url.map((segment) => segment.path).join('/');
        const queryParams = route.queryParams ? '?' + new URLSearchParams(route.queryParams).toString() : '';
        const fragment = route.fragment ? '#' + route.fragment : '';
        const newUrl = this.languageRoutingService.getLocalizedRoute(fullPath + queryParams + fragment, defaultLang);
        this.router.navigateByUrl(newUrl, { replaceUrl: true });
        return false;
      }
    }

    return true;
  }
}
